import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            idClient:    yup.string().required(__(`form.idClient.error`)),
            date:        yup.string().required(__(`form.date.error`)),
            division:    yup.string().required(__(`form.division.error`)),
            invoiceType: yup.string().required(__(`form.invoiceType.error`)),
        })
    )
}

export default validators;
